import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stringFieldSelector } from 'redux/schemaSlice';
import {
  singleGeometryFieldSet,
  geometryFormatSet,
  singleGeometryFieldSelector,
  geometryFormatSelector
} from 'redux/keyFieldsSlice';

import { FormControl } from 'components/StyledComponents';

import Select from 'components/Select';
import SpatialReference from './SpatialReference';
import GeometryTypeSelect from './GeometryTypeSelect';

import { CalciteLabel, CalciteOption } from 'components/Calcite';

const SingleGeometryField: React.FC = () => {
  const dispatch = useDispatch();

  const singleFieldCandidates = useSelector(stringFieldSelector);
  const singleField = useSelector(singleGeometryFieldSelector);
  const geometryFormat = useSelector(geometryFormatSelector);

  return (
    <>
      <FormControl>
        <CalciteLabel>Geometry Field</CalciteLabel>
        <Select
          label="Geometry Field"
          value={singleField}
          onChange={value => dispatch(singleGeometryFieldSet(value as string))}
          options={singleFieldCandidates.map(({ fieldName, displayName }) => (
            <CalciteOption
              key={fieldName}
              selected={singleField === fieldName}
              value={fieldName}
            >
              {displayName}
            </CalciteOption>
          ))}
        />
      </FormControl>
      <GeometryTypeSelect />
      <FormControl>
        <CalciteLabel>Geometry Format</CalciteLabel>
        <Select
          label="Geometry Format"
          value={geometryFormat}
          onChange={value => dispatch(geometryFormatSet(value as string))}
          options={[
            <CalciteOption
              key="coordinates"
              selected={geometryFormat === 'coordinates'}
              value="coordinates"
            >
              Coordinates
            </CalciteOption>,
            <CalciteOption
              key="esrijson"
              selected={geometryFormat === 'esrijson'}
              value="esrijson"
            >
              EsriJSON
            </CalciteOption>,
            <CalciteOption
              key="geojson"
              selected={geometryFormat === 'geojson'}
              value="geojson"
            >
              GeoJSON
            </CalciteOption>,
            <CalciteOption
              key="wkt"
              selected={geometryFormat === 'wkt'}
              value="wkt"
            >
              WKT
            </CalciteOption>
          ]}
        />
      </FormControl>
      <SpatialReference />
    </>
  );
};
export default SingleGeometryField;
